import { I3pService } from '@nuxtDatakodeUtils/services/i3p.service'
import type { I3pServiceInterface } from '@nuxtDatakodeUtils/services/i3p.service.interface'
import { Entity } from '~/models/Entity'

export class MainI3pService extends I3pService<any> implements I3pServiceInterface {
    getModel(): Entity {
        return new Entity()
    }

    getLayerName(): string {
        return ''
    }
}
